import { render, staticRenderFns } from "./inpatient.vue?vue&type=template&id=72f5c3b6&scoped=true"
import script from "./inpatient.vue?vue&type=script&lang=js"
export * from "./inpatient.vue?vue&type=script&lang=js"
import style0 from "./inpatient.vue?vue&type=style&index=0&id=72f5c3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f5c3b6",
  null
  
)

export default component.exports